import { Injectable } from '@angular/core';
import { BaseHandler } from '@rx-applications/shared/logging';
import { InitProperties } from '../models/init-properties';
import { LoggingPropertyConfiguration } from '../models/logging-property-configuration';

@Injectable({ providedIn: 'root' })
export abstract class ClientsiteBaseHandler extends BaseHandler<InitProperties, LoggingPropertyConfiguration> {
  // Default access modifier should be protected. However until logging will be fully migrated to new module it needs to be set as public.
  // It is used in old handlers to provide backward compatibility.
  // ...\apps\clientsite\src\app\core\modules\logging\handlers\...
  public enabled = false;
}
